/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    AggregationAverageMethod,
    instanceOfAggregationAverageMethod,
    AggregationAverageMethodFromJSON,
    AggregationAverageMethodFromJSONTyped,
    AggregationAverageMethodToJSON,
} from './AggregationAverageMethod';
import {
    AggregationDistinctMethod,
    instanceOfAggregationDistinctMethod,
    AggregationDistinctMethodFromJSON,
    AggregationDistinctMethodFromJSONTyped,
    AggregationDistinctMethodToJSON,
} from './AggregationDistinctMethod';
import {
    AggregationFirstMethod,
    instanceOfAggregationFirstMethod,
    AggregationFirstMethodFromJSON,
    AggregationFirstMethodFromJSONTyped,
    AggregationFirstMethodToJSON,
} from './AggregationFirstMethod';
import {
    AggregationLastMethod,
    instanceOfAggregationLastMethod,
    AggregationLastMethodFromJSON,
    AggregationLastMethodFromJSONTyped,
    AggregationLastMethodToJSON,
} from './AggregationLastMethod';
import {
    AggregationMaxMethod,
    instanceOfAggregationMaxMethod,
    AggregationMaxMethodFromJSON,
    AggregationMaxMethodFromJSONTyped,
    AggregationMaxMethodToJSON,
} from './AggregationMaxMethod';
import {
    AggregationMinMethod,
    instanceOfAggregationMinMethod,
    AggregationMinMethodFromJSON,
    AggregationMinMethodFromJSONTyped,
    AggregationMinMethodToJSON,
} from './AggregationMinMethod';
import {
    AggregationSumMethod,
    instanceOfAggregationSumMethod,
    AggregationSumMethodFromJSON,
    AggregationSumMethodFromJSONTyped,
    AggregationSumMethodToJSON,
} from './AggregationSumMethod';
import {
    AggregationWithoutFieldMethod,
    instanceOfAggregationWithoutFieldMethod,
    AggregationWithoutFieldMethodFromJSON,
    AggregationWithoutFieldMethodFromJSONTyped,
    AggregationWithoutFieldMethodToJSON,
} from './AggregationWithoutFieldMethod';

/**
 * @type AggregationMethod
 * 
 * @export
 */
export type AggregationMethod = { operator: 'Average' } & AggregationAverageMethod | { operator: 'Count' } & AggregationWithoutFieldMethod | { operator: 'Distinct' } & AggregationDistinctMethod | { operator: 'First' } & AggregationFirstMethod | { operator: 'Last' } & AggregationLastMethod | { operator: 'Max' } & AggregationMaxMethod | { operator: 'Min' } & AggregationMinMethod | { operator: 'Sum' } & AggregationSumMethod;

export function AggregationMethodFromJSON(json: any): AggregationMethod {
    return AggregationMethodFromJSONTyped(json, false);
}

export function AggregationMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregationMethod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['operator']) {
        case 'Average':
            return {...AggregationAverageMethodFromJSONTyped(json, true), operator: 'Average'};
        case 'Count':
            return {...AggregationWithoutFieldMethodFromJSONTyped(json, true), operator: 'Count'};
        case 'Distinct':
            return {...AggregationDistinctMethodFromJSONTyped(json, true), operator: 'Distinct'};
        case 'First':
            return {...AggregationFirstMethodFromJSONTyped(json, true), operator: 'First'};
        case 'Last':
            return {...AggregationLastMethodFromJSONTyped(json, true), operator: 'Last'};
        case 'Max':
            return {...AggregationMaxMethodFromJSONTyped(json, true), operator: 'Max'};
        case 'Min':
            return {...AggregationMinMethodFromJSONTyped(json, true), operator: 'Min'};
        case 'Sum':
            return {...AggregationSumMethodFromJSONTyped(json, true), operator: 'Sum'};
        default:
            throw new Error(`No variant of AggregationMethod exists with 'operator=${json['operator']}'`);
    }
}

export function AggregationMethodToJSON(value?: AggregationMethod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['operator']) {
        case 'Average':
            return AggregationAverageMethodToJSON(value);
        case 'Count':
            return AggregationWithoutFieldMethodToJSON(value);
        case 'Distinct':
            return AggregationDistinctMethodToJSON(value);
        case 'First':
            return AggregationFirstMethodToJSON(value);
        case 'Last':
            return AggregationLastMethodToJSON(value);
        case 'Max':
            return AggregationMaxMethodToJSON(value);
        case 'Min':
            return AggregationMinMethodToJSON(value);
        case 'Sum':
            return AggregationSumMethodToJSON(value);
        default:
            throw new Error(`No variant of AggregationMethod exists with 'operator=${value['operator']}'`);
    }

}

